import { render, staticRenderFns } from "./SAPBaseCustomerMaterialMappingEdit.vue?vue&type=template&id=4543359e&scoped=true"
import script from "./SAPBaseCustomerMaterialMappingEdit.vue?vue&type=script&lang=js"
export * from "./SAPBaseCustomerMaterialMappingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543359e",
  null
  
)

export default component.exports